import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import GalleryList from '../gallery/gallery';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { mainListItems, secondaryListItems } from '../listItems';
import Profile from '../profile'
import { messsageLogin, fetchData } from '../loginPageService'
import StepsComponent from './StepsComponent';
import AlwaysOnBoolingIcon from '../BookingIcon/AlwaysOnBookingIcon';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import RideBookingForm from '../dashboard/RideBookingForm'
import AboutContent from '../dashboard/AboutContent'
import Stack from '@mui/material/Stack';
import CarsGridTemplate from '../CarsGrid/CarsGrid'
import ReviewsGrid from '../ReviewsGrid/ReviewsGrid'
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import "../CSS/styles.css";
import { Helmet } from 'react-helmet';
import Carousel from 'react-bootstrap/Carousel';
import Modal from '../modal/modal';
import Welcome from '../../content/Welcome'
import { CommonContext } from '../modal/Context';
import JustDial from './JustDial';
import MobileReviewGrid from '../ReviewsGrid/MobileReviewGrid';
import StructuredData from '../StructuredData';
import ServiceStatsCard from '../Service/ServiceStatsCard';
import TableComponent from '../modal/TableComponent';
import ServiceFeatures from './ServiceFeatures';
function Copyright(props) {
  return (
    <>
      <Helmet>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="SVR Taxi Service | Call us 9965821750" />
        <meta charset="UTF-8" />
        <meta property="og:locale" content="en_IN" />
        <meta property="og:url" content="https://svrtaxi.netlify.app/salem-best-taxi"/>
        <meta property="og:image" content="https://svrtaxi.netlify.app/VisitingCard.jpg" />
        <meta name="description" content="Reliable, taxi & cab,cabs service in Salem, and, across India. Available 24/7 and drivers and affordable pricing. Book now for a comfortable journey "/>
        <meta name="keywords" content="taxi ,service, Salem, India, airport, transfers, intercity, travel, taxi ,booking,svr taxi,Affordable, taxi ,service ,from ,Salem, to ,Chennai,Best, outstation, cab ,service, from ,Salem ,to ,Kodaikanal,Taxi ,service ,for ,day, trips, in ,and, around, Salem,One-way ,taxi ,service ,from ,Salem ,to ,Bangalore,Book ,a, cab, for ,Salem to ,Tiruchirappalli ,trip,Salem to ,Yercaud ,cab ,service for ,family ,trips,Reliable ,24-hour, taxi, service in Salem,Taxi booking, for airport transfers, in Salem,Safe, taxi, service ,for solo ,women, travelers ,in Salem,Outstation, cab, services ,from Salem ,for business ,trips,Affordable car ,rental ,for Salem, sightseeing,Affordable ,Salem to ,Ooty, weekend, tour ,packages,Salem to ,Munnar, taxi, service with sightseeing packages,Pilgrimage, taxi service from, Salem to ,Samayapuram, Temple,
    Budget ,taxi, packages, from Salem to ,Hogenakkal, Falls,Cab service for Salem to ,Kodaikanal, honeymoon, package,Luxury, taxi service, for ,corporate ,trips, from Salem to ,Chennai,Round-trip, taxi ,service ,from Salem to, Mysore,Car, rental, with, driver, for ,outstation trips, in ,Tamil Nadu,Customized, tour packages, with taxi service in Tamil Nadu,
    Cheap, cab ,service for ,outstation trips, from Salem, best, taxi service in salem , best , taxi , service , Best taxi service in salem , Best Cab service in salem,, contact us 9965821750 to book ride"/>
      
        <meta name="author" content="SVR Taxi" />
        <title>Cab , Taxi Service salem | Call us 9965821750 | SVR | Best Cabs Service | Call Taxi Service</title>


        <meta property="og:title" content="SVR- Taxi Service in Salem & Across India" />

        <link rel="canonical" href="https://svrtaxi.netlify.app/salem-best-taxi" />
        <link rel="stylesheet" href="%PUBLIC_URL%/styles.css" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap"  />

      </Helmet>
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '}
        <Link color="inherit" href="https://mui.com/">
          SVR TAXI
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    </>
  );
}

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        display: 'none',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function SalemBestTaxi() {
  const [data, setData] = React.useState(null); // Store your data here
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [isMobile, setIsMobile] = React.useState(false);

  const [isLargeScreen, setIsLargeScreen] = React.useState(false);


  const { welcomeModal, setWelcomeModal , getTeriffDataList } = useContext(CommonContext);

  // const sendWhatsAppMessage = firebase.functions().httpsCallable('sendWhatsAppMessage');




  // React.useEffect(() => {
  //   const fetchAllData = async () => {
  //     try {
  //       setLoading(true); // Set loading state before making API calls
  //       const response = await messsageLogin("djfksjdlf", "dnfkjsdlkjflsdk");

  //       if (response.status === 200) {
  //         console.log("Response data:", response.data); // Handle response data
  //         setData(response.data); // Store data in state
  //       } else {
  //         // Handle non-200 response status if necessary
  //         setError(new Error(`Unexpected status code: ${response.status}`));
  //       }
  //     } catch (error) {
  //       setError(error); // Set error state if API call fails
  //     } finally {
  //       setLoading(false); // Set loading state to false regardless of success or failure
  //     }
  //   };



  //   fetchAllData();
  // }, []);



  React.useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true); // Set loading state before making API calls
        const response = await fetchData();

        if (response.status === 200) {
          console.log("Response data:", response.data); // Handle response data
          setData(response.data); // Store data in state
        } else {
          // Handle non-200 response status if necessary
          setError(new Error(`Unexpected status code: ${response.status}`));
        }
      } catch (error) {
        setError(error); // Set error state if API call fails
      } finally {
        setLoading(false); // Set loading state to false regardless of success or failure
      }
    };



    fetchAllData();
  }, []);
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const checkDeviceWidth = () => {
    // You can adjust the width breakpoint as needed
    if (window.innerWidth >= 768) {
      setOpen(true);

      setIsMobile(false);
      setIsLargeScreen(true);
    } else {
      setOpen(false);
      setIsMobile(window.innerWidth <= 768);
      setIsLargeScreen()
      // Open the drawer on tablets and laptops
      // Keep the drawer closed on mobile devices
    }
  };

  React.useEffect(() => {
    // Set initial drawer state based on device width
    checkDeviceWidth();

    // Add resize event listener to handle screen resizing
    window.addEventListener('resize', checkDeviceWidth);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkDeviceWidth);
    };
  }, []);

  const [showModal, setShowModal] = React.useState(true); // State to track modal visibility

  const handleCloseModal = () => {
    setShowModal(true); // Function to close the modal
  };

  const StyledGrid = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(2.5),  // 20px margin top
    gap: theme.spacing(2.5)         // 20px column gap
  }));

  const StyledParagraph = styled('p')({
    textAlign: 'left'               // Left-align text
  });

  const stats = {
    customers: 1500,
    rides: 12000,
    drivers: 300,
    cities: 20,
    distance: 500000,  // in kilometers
    safetyRating: 4.8,  // out of 5
    avgWaitTime: 5,     // in minutes
    fleetSize: 500      // total vehicles
  };

  const teriffData = getTeriffDataList();
  

  return (
    <><StructuredData /><Container maxWidth="xl" sx={{ mt: 4, mb: 4, }} xl={12}>
      <AlwaysOnBoolingIcon />
      <Grid container >
        {/* Chart */}
        <Grid item xs={12} md={8} lg={8}>
          {/*  <Paper
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: 240,
            }}
          >
<img src="/images/login/taxi-group-photo.jpeg" alt="Lock" style={{ width: '100%', height: '100%' }} />

          </Paper> */}

          <Carousel fade style={{ height: '100%' }} indicators={false} controls={true}>
            <Carousel.Item style={{ height: '100%' }}>
              <img
                className="d-block w-100" style={{ height: '100%' }}
                src="/images/salem-to-coimbatore.webp" alt="Salem to Coimbatore Cab Services" />

              <Carousel.Caption>

              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item style={{ height: '100%' }}>
              <img
                className="d-block w-100" style={{ height: '100%' }}
                src="/images/salem-to-mettur-dam.webp" alt="Mettur Dam Cab Services" />

              <Carousel.Caption>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item style={{ height: '100%' }}>
              <img
                className="d-block w-100" style={{ height: '100%' }}
                src="/images/salem-to-kodaikanal.webp" alt="Salem To Kodaikanal Cab Services" />

              <Carousel.Caption>

              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>

        </Grid>
        {/* Recent Deposits */}
        <Grid item xs={12} md={4} lg={4}>

          <RideBookingForm style={{ height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#F9C78B' }} />

          {/*    <MobileNumberAuthentication style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}/> */}

        </Grid>

        {welcomeModal && (
          <Modal heading={"Welcome to SVR Taxi"} action={false}>
            <Welcome />
          </Modal>
        )}
        <Grid sx={{ marginTop: 10 }} className={isMobile ? "mobile-class" : ""}>
          <h1 style={{ fontSize: 'larger' }}>Best Taxi & Cab Service in Salem</h1>
          <hr />
          <Box>
            <h6>
              Looking for the <h1 style={{ fontSize: '18px', display: 'inline-flex', fontWeight: '100px' }}>Best cab & cabs service in Salem</h1>? Look no further than SVR Taxi, your trusted partner for safe, reliable, and affordable transportation. Whether you need a ride across town or a long-distance journey, we provide top-notch service with professional drivers and well-maintained vehicles, ensuring a comfortable experience for every trip.
            </h6>
          </Box>
        </Grid>
        <ServiceStatsCard
        customers={stats.customers}
        rides={stats.rides}
        drivers={stats.drivers}
        cities={stats.cities}
        distance={stats.distance}
        safetyRating={stats.safetyRating}
        avgWaitTime={stats.avgWaitTime}
      />
        
          {/* Recent Orders */}
          <div style={{width:'100%',textAlign:'center',margin:'30px'}}>
          
     <h5>Car is Your Choice</h5>
     <hr></hr>
     </div>

        <CarsGridTemplate />

      </Grid>

      <TableComponent
                title={teriffData.localPackage.title}
                columns={teriffData.localPackage.columns}
                rows={teriffData.localPackage.rows}
                tableType="local-package"
            />
             <TableComponent
                title={teriffData.yercardPackage.title}
                columns={teriffData.yercardPackage.columns}
                rows={teriffData.yercardPackage.rows}
                tableType="yercard-package"
            />
   <TableComponent
                title={teriffData.package.title}
                columns={teriffData.package.columns}
                rows={teriffData.package.rows}
                tableType="local-package"
            />
      <Box sx={{ textAlign: 'center', mt: 10, width: '100%', mb: 10 }} className={isMobile ? "mobile-class-about" : ""}>
        <h2 style={{ fontSize: 'medium' }}>Just Dial And Book Your Ride</h2>
        <hr style={{ width: '50%', margin: '0 auto', borderTop: '2px solid #000' }} />
      </Box>
      <Grid container sx={{ mb: 10 }} className={isMobile ? "mobile-class-about" : ""}>
        <Stack spacing={3} direction="row" className={isMobile ? "mobile-class-about" : ""}>
          <JustDial className={isMobile ? "mobile-class-about" : ""} />
        </Stack>
      </Grid>
      <Box className={isMobile ? "mobile-class-steps" : ""}>
        <StyledGrid container spacing={2.5} className={isMobile ? "mobile-class" : ""}>
          <Grid container sx={{ backgroundColor: 'white' }}>
            <Grid item xs={12} md={12} lg={4} sx={{ p: 2 }}>
              <p>
                <strong>How It Works</strong>
                <br /><br />
                <StyledParagraph>
                  To use a <h2 style={{ fontSize: '18px', display: "inline-flex" }}> Taxi services, customers can book a ride </h2> via phone, mobile app, website, or at a taxi stand. Once booked, the service's dispatch system assigns a nearby driver who then receives the pickup details. The driver arrives at the specified location, picks up the customer, and takes them to their destination, using navigation tools for efficiency. Payment can be made in cash, by card, or electronically through the app. After the ride, the customer can provide feedback and receive a receipt, while both driver and customer can rate each other to ensure quality service.
                </StyledParagraph>
              </p>
            </Grid>
            <Grid item xs={12} md={12} lg={2} sx={{ p: 2 }}>
              <img src="/images/login/Dashboard/Assert/steps_booking_taxi.webp" alt="First slide" />
             
            </Grid>
            <Grid item xs={12} md={12} lg={6} sx={{ p: 2 }}>

              <p>
                <strong>Steps</strong>
                <br />
                <StyledParagraph>
                  <StepsComponent />
                </StyledParagraph>
              </p>
            </Grid>
          </Grid>
        </StyledGrid>
      </Box>
      <Box sx={{ mt: 10 }} className={isMobile ? "mobile-class" : ""}>
        <Box sx={{ textAlign: 'center', backgroundColor: '#FBD86C', mt: 10 }}>
          <h1 style={{ fontSize: '30px', fontWeight: '20px', paddingTop: 20 }}>Why Choose SVR Taxi?</h1>
          <hr style={{ width: '50%', margin: '0 auto', borderTop: '2px solid #000' }} />
        </Box>
        <ServiceFeatures />
       </Box>
      <Box sx={{ textAlign: 'center', mt: 10, width: '100%', mb: 10 }} className={isMobile ? "mobile-class-about" : ""}>
        <h1 style={{ fontSize: 'larger' }}>About Us</h1>
        <hr style={{ width: '50%', margin: '0 auto', borderTop: '2px solid #000' }} />
      </Box>
      <Grid container sx={{ mb: 10 }} className={isMobile ? "mobile-class-about" : ""}>
        <Stack spacing={3} direction="row" className={isMobile ? "mobile-class-about" : ""}>
          <AboutContent className={isMobile ? "mobile-class-about" : ""} />
        </Stack>
      </Grid>
      <Carousel fade>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="/images/salem-to-madurai.webp" alt="First slide" />

          <Carousel.Caption>
            <h3>First slide label</h3>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="/images/salem-to-chennai.webp" alt="First slide" />

          <Carousel.Caption>
            <h3>Second slide label</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="/images/salem-to-yercaud.webp" alt="First slide" />

          <Carousel.Caption>
            <h3>Salem To Yercaud</h3>
            <p>
              Praesent commodo cursus magna, vel scelerisque nisl consectetur.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
      <Box sx={{ textAlign: 'center', mt: 10, width: '100%', mb: 10 }}>
        <h3>Reviews</h3>
        <hr style={{ width: '50%', margin: '0 auto', borderTop: '2px solid #000' }} />
      </Box>
      <Grid container className={isMobile ? "d-n" : "d-b"}>
        <Stack spacing={3} direction="row" className={isMobile ? "d-n" : "d-b"}>
          <ReviewsGrid className={isMobile ? "d-n" : "d-b"} />
        </Stack>
      </Grid>
      <Grid container className={isMobile ? "d-b" : "d-n"}>
        <Stack spacing={3} direction="row" className={isMobile ? "d-b" : "d-n"}>
          <MobileReviewGrid className={isMobile ? "d-b" : "d-n"} />
        </Stack>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: '20px' }}>
      {/* Left Side - Links */}
      <Grid
        item
        xs={12}
        md={3}
        lg={3}
        style={{
          backgroundImage: `url('/images/login/Travel-world.png')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          height:'350px'
        }}
      >
       <></>
      </Grid>

      {/* Right Side - Video Content */}
      <Grid
        item
        xs={12}
        md={9}
        lg={9}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height:'350px',
          width:'100%'
        }}
      >
        <video width="100%" height="100%" controls={false} loop autoPlay muted>
          <source
            src="/images/login/mobile-with-taxi.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </Grid>
    </Grid>
      <GalleryList />
      <Copyright sx={{ pt: 4 }} />
    </Container>
    </>


  );
}